"use client";
import { j as r } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as o } from "./tv.config-BuYIgndg.mjs";
const c = o({
  base: ["Card__action", "p-5", "pt-0"],
  variants: {}
}), i = (s) => {
  const { className: t, ...a } = s;
  return /* @__PURE__ */ r.jsx("div", { ...a, className: c({ class: t }) });
};
export {
  i as default
};
